/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { WarehouseMovement } from '../../models/warehouse-movement';

export interface WarehouseControllerGetMovement$Params {
  idMovement: number;
}

export function warehouseControllerGetMovement(http: HttpClient, rootUrl: string, params: WarehouseControllerGetMovement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WarehouseMovement;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerGetMovement.PATH, 'get');
  if (params) {
    rb.path('idMovement', params.idMovement, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WarehouseMovement;
      }>;
    })
  );
}

warehouseControllerGetMovement.PATH = '/warehouse/movements/{idMovement}';
